/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import {
  Card, CardBody, Col, CardHeader, ModalFooter,
  Row, Button, Modal, ModalHeader, ModalBody,
  Label, FormGroup, Input } from 'reactstrap'
import Select from '../../../components/Template/Input/Select'
import { selectValues, getRegs, getReg, insOrUp, validarCPF } from '../../../utils/fc'
import DataTable from '../../../components/Template/Table/DataTable'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { v4 as uuid } from 'uuid'
import AsyncSelect from '../../../components/Template/Input/AsyncSelect'
import AsyncCreatableSelect from '../../../components/Template/Input/AsyncCreatableSelect'
import oikosApi from '../../../services/oikos'
import { notifyError, notifySuccess } from '../../../utils/notify'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import ModalConfirmacao from '../../../components/Modals/ModalConfirmacao/ModalConfirmacao'
import qs from 'qs'


class StakeProj extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: false,
      project: false,
      pj_id: false,
      dataIsLoading: false,
      selPapel: false,
      selStakeProj: false,
      selPfs: false,
      addStakeProjModalIsOpen: false,
      editStakeProjModalIsOpen: false,
      addStakeProjData: false,
      editStakeProjData: false,
      addPfModalIsOpen: false,
      addPfData: {},
      addPfIsLoading: false,
      deleteConfirmOpen: false,
      deleteTarget: null,
      deleteIsLoading: false,
    }
  }

  componentDidMount() {
    this.preloading()
  }

  componentDidUpdate(prevProps) {
    const prevProjId = prevProps.project?.proj_id || prevProps.projId
    const nextProjId = this.props.project?.proj_id || this.props.projId
    if (prevProjId !== nextProjId && nextProjId) {
      this.preloading()
    }
    if (prevProps.refreshAt !== this.props.refreshAt && this.props.refreshAt) {
      this.preloading()
    }
  }

  handleSubmit = async () => {
    const { addStakeProjData } = this.state
    if (!addStakeProjData?.pf_id) {
      notifyError('Selecione uma pessoa física.')
      return false
    }
    if (!addStakeProjData?.papel_id) {
      notifyError('Selecione a atuação.')
      return false
    }

    try {
      await oikosApi.post('/', {
        action: 'insert',
        table: 'projStake',
        data: {
          proj_id: this.props.project.proj_id,
          pf_id: addStakeProjData.pf_id,
          papel_id: addStakeProjData.papel_id,
          projStake_usuarioCria: this.props.user.pf_id,
          projStake_usuarioMod: this.props.user.pf_id,
        },
      })
      await this.preloading()
      return true
    } catch (err) {
      console.error('Error in handleSubmit:', err)
      notifyError('Não foi possível adicionar o stakeholder.')
      return false
    }
  };

  openAddPfModal = () => {
    this.setState({
      addPfModalIsOpen: true,
      addPfData: {
        pf_nomeExibicao: '',
        pf_emailProf: '',
        pf_celProf: '',
        pf_cpf: '',
      },
    })
  }

  closeAddPfModal = () => {
    if (this.state.addPfIsLoading) return
    this.setState({ addPfModalIsOpen: false, addPfData: {} })
  }

  handleCreatePf = async () => {
    const { addPfData } = this.state
    const nome = (addPfData.pf_nomeExibicao || '').trim()
    const email = (addPfData.pf_emailProf || '').trim()
    const celular = (addPfData.pf_celProf || '').trim()
    const cpf = String(addPfData.pf_cpf || '').replace(/\D/g, '')

    if (!nome) {
      notifyError('Nome é obrigatório.')
      return
    }
    if (!email) {
      notifyError('E-mail é obrigatório.')
      return
    }
    if (!cpf) {
      notifyError('CPF é obrigatório.')
      return
    }
    if (!validarCPF(cpf)) {
      notifyError('CPF inválido.')
      return
    }
    if (!celular) {
      notifyError('Telefone/celular é obrigatório.')
      return
    }

    this.setState({ addPfIsLoading: true })
    try {
      const existing = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        data: { pf_cpf: cpf },
      })}`)
      if (Array.isArray(existing.data) && existing.data[0]) {
        notifyError('Já existe uma PF cadastrada com este CPF.')
        this.setState({ addPfIsLoading: false })
        return
      }

      const pfPayload = {
        pf_nomeExibicao: nome,
        pf_emailProf: email,
        pf_celProf: celular,
        pf_cpf: cpf,
        pf_usuarioCria: this.props.user.pf_id,
        pf_usuarioMod: this.props.user.pf_id,
      }
      const pjId = this.props.project.contrato_contratante || this.state.pj_id
      if (pjId) pfPayload.pj_id = pjId

      const res = await oikosApi.post('/', {
        action: 'insert',
        table: 'pf',
        data: pfPayload,
      })

      const newPfId = res?.data?.[0]?.pf_id || res?.data?.[0]?.id
      if (!newPfId) {
        throw new Error('PF criada sem id retornado')
      }

      const pfs = await selectValues('pf', 'pf_id', 'pf_nomeExibicao')
      this.setState(prev => ({
        selPfs: pfs,
        addPfModalIsOpen: false,
        addPfData: {},
        addPfIsLoading: false,
        addStakeProjData: {
          ...prev.addStakeProjData,
          proj_id: this.props.project.proj_id,
          pf_id: newPfId,
        },
      }))
      notifySuccess('PF cadastrada. Selecione a atuação e clique em Adicionar.')
    } catch (err) {
      console.error('Error in handleCreatePf:', err)
      this.setState({ addPfIsLoading: false })
      notifyError('Não foi possível cadastrar a PF.')
    }
  };

  handleEditSubmit = async () => {
    try {
      console.log('dentro do handleEditSubmit', this.state.editStakeProjData);
      const editPfBody = {
        pf_id: this.state.editStakeProjData.pf_id,
        pf_nomeExibicao: this.state.editStakeProjData.pf_nomeExibicao,
        pf_cargo: this.state.editStakeProjData.papel_nome,
        pf_celProf: this.state.editStakeProjData.pf_celProf,
        pf_emailProf: this.state.editStakeProjData.pf_emailProf,
        pf_usuarioMod: this.props.user?.pf_id,
      };
      const editStakeholderBody = {
        projStake_id: this.state.editStakeProjData.projStake_id,
        papel_id: this.state.editStakeProjData.papel_id,
        projStake_usuarioMod: this.props.user?.pf_id,
      };
      await insOrUp('pf', editPfBody);
      await insOrUp('projStake', editStakeholderBody);
      this.setState({ editStakeProjData: {}, editStakeProjModalIsOpen: false });
      await this.preloading();
    } catch (err) {
      console.error("Error in handleEditSubmit:", err);
      notifyError('Não foi possível salvar o stakeholder.')
    }

  };

  openDeleteConfirm = (row) => {
    this.setState({
      deleteConfirmOpen: true,
      deleteTarget: {
        projStake_id: row.projStake_id,
        pf_nomeExibicao: row.pf_nomeExibicao,
      },
    })
  }

  closeDeleteConfirm = () => {
    if (this.state.deleteIsLoading) return
    this.setState({ deleteConfirmOpen: false, deleteTarget: null })
  }

  handleDelete = async () => {
    const { deleteTarget } = this.state
    if (!deleteTarget?.projStake_id) return
    this.setState({ deleteIsLoading: true })
    try {
      await insOrUp('projStake', {
        projStake_id: deleteTarget.projStake_id,
        projStake_ativo: 0,
        projStake_usuarioMod: this.props.user?.pf_id,
      })
      this.setState({ deleteConfirmOpen: false, deleteTarget: null, deleteIsLoading: false })
      await this.preloading()
    } catch (err) {
      console.error('Error in handleDelete:', err)
      this.setState({ deleteIsLoading: false })
      notifyError('Não foi possível excluir o stakeholder.')
    }
  };

  preloading = async() => {
    this.setState({dataIsLoading: true })
    const pfs = await selectValues('pf', 'pf_id', 'pf_nomeExibicao')
    this.setState({selPfs: pfs })

    const data = await getRegs('projStake', {proj_id: this.props.project.proj_id },
    {
			'(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = projStake.pf_id)': 'pf_nomeExibicao',
			'(SELECT pf_emailProf FROM pf WHERE pf.pf_id = projStake.pf_id)': 'pf_emailProf',
			'(SELECT pf_celProf FROM pf WHERE pf.pf_id = projStake.pf_id)': 'pf_celProf',
      '(SELECT papel_nome FROM papel WHERE papel.papel_id = projStake.papel_id)': 'papel_nome',
		} )
    console.log("lista do StakeProj ", data)

    const project = await getReg('proj', this.props.project.proj_id, {
			'(SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'pj_id',
		} )
    console.log("projeto: ", project)
    this.setState({project, pj_id: project.pj_id})
    console.log("contratante: ", project.pj_id)

    this.setState({ data, dataIsLoading: false })

    this.setState({ selStakeProj: await getRegs('pf', { pj_id: project.pj_id}) })
    console.log('lista pf = ', this.state.selStakeProj)
    this.setState({ selPapel: await selectValues('papel', 'papel_id', 'papel_nome') })
    console.log('lista papel = ', this.state.selPapel)
  }


  render() {

    const {
      dataIsLoading, data, selPapel, addStakeProjModalIsOpen, addStakeProjData,
      editStakeProjData, editStakeProjModalIsOpen, deleteConfirmOpen, deleteTarget, deleteIsLoading,
      addPfModalIsOpen, addPfData, addPfIsLoading,
    } = this.state

    if (dataIsLoading) {
      return (
        <Card>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (data) {
      return (
        <>

        <ModalConfirmacao
          openModal={deleteConfirmOpen}
          title="Excluir stakeholder"
          text={deleteTarget?.pf_nomeExibicao
            ? `Tem certeza que deseja excluir "${deleteTarget.pf_nomeExibicao}"?`
            : 'Tem certeza que deseja excluir este stakeholder?'}
          confirmButtonText="Excluir"
          confirmButtonColor="danger"
          cancelButtonText="Cancelar"
          onClosed={this.closeDeleteConfirm}
          onConfirm={this.handleDelete}
          isLoading={deleteIsLoading}
        />

        <Button
          size="sm"
          color="link"
          className="mb-1 ml-1 px-0"
          onClick={() => this.setState({
            addStakeProjModalIsOpen: true,
            addStakeProjData: { proj_id: this.props.project.proj_id },
          })}
        >
          Adicionar novo
        </Button>
        <Modal
          centered={false}
          isOpen={addStakeProjModalIsOpen}
          toggle={() => this.setState({ addStakeProjData: {}, addStakeProjModalIsOpen: false })}
        >
          <ModalHeader
            toggle={() => this.setState({
              addStakeProjData: {},
              addStakeProjModalIsOpen: false,
            })}
          >
            Adicionar novo
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <div className="d-flex align-items-center justify-content-between mb-1">
                <Label className="mb-0">
                  Selecione a Pessoa Física
                </Label>
                <Button
                  size="sm"
                  color="link"
                  className="ml-2 px-0"
                  onClick={(e) => {
                    e.preventDefault()
                    this.openAddPfModal()
                  }}
                >
                  Adicionar nova PF
                </Button>
              </div>

              <Select
                classNamePrefix="select2-selection"
                isSearchable
                placeholder="Selecionar..."
                value={this.state.selPfs && this.state.selPfs?.filter(x => (x.value === addStakeProjData.pf_id))}
                options={this.state.selPfs || []}
                onChange={e => this.setState({
                  addStakeProjData: {
                    ...addStakeProjData,
                    pf_id: e.value,
                  },
                })}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Atuação
              </Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecionar..."
                value={selPapel && selPapel?.filter(x => (x.value === addStakeProjData.papel_id))}
                options={selPapel || []}
                isDisabled={!selPapel}
                isLoading={!selPapel}
                onChange={e => this.setState({
                  addStakeProjData: {
                    ...addStakeProjData,
                    papel_id: e.value,
                    papel_nome: e.label,
                  },
                })}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.setState({ addStakeProjData: {}, addStakeProjModalIsOpen: false })}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                const ok = await this.handleSubmit()
                if (ok) {
                  this.setState({ addStakeProjData: {}, addStakeProjModalIsOpen: false })
                }
              }}
            >
              Adicionar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          centered={false}
          isOpen={addPfModalIsOpen}
          toggle={this.closeAddPfModal}
          zIndex={1050}
        >
          <ModalHeader toggle={this.closeAddPfModal}>
            Adicionar nova PF
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Nome</Label>
              <Input
                value={addPfData.pf_nomeExibicao || ''}
                onChange={e => this.setState({
                  addPfData: { ...addPfData, pf_nomeExibicao: e.target.value },
                })}
              />
            </FormGroup>
            <FormGroup>
              <Label>CPF</Label>
              <MaskedInput
                unmask
                mask="000.000.000-00"
                lazy={false}
                disabled={false}
                value={addPfData.pf_cpf?.toString() || ''}
                onAccept={value => {
                  this.setState({
                    addPfData: { ...addPfData, pf_cpf: value || '' },
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label>E-mail</Label>
              <Input
                type="email"
                value={addPfData.pf_emailProf || ''}
                onChange={e => this.setState({
                  addPfData: { ...addPfData, pf_emailProf: e.target.value },
                })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Celular</Label>
              <MaskedInput
                unmask
                mask="(00) 00000-0000"
                lazy={false}
                disabled={false}
                value={addPfData.pf_celProf?.toString() || ''}
                onAccept={value => {
                  this.setState({
                    addPfData: { ...addPfData, pf_celProf: value || '' },
                  })
                }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={this.closeAddPfModal}
              color="light"
              className="waves-effect"
              disabled={addPfIsLoading}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={this.handleCreatePf}
              disabled={addPfIsLoading}
            >
              {addPfIsLoading ? 'Salvando...' : 'Cadastrar PF'}
            </Button>
          </ModalFooter>
        </Modal>


        <Modal
          centered={false}
          isOpen={ editStakeProjModalIsOpen}
          toggle={() => this.setState({ editStakeProjData: {}, editStakeProjModalIsOpen: false })}
        >
          <ModalHeader>
            Editar Stakeholder
          </ModalHeader>
          <ModalBody>

            {editStakeProjData &&
              <>
                <FormGroup>
                  <Label>
                    Nome
                  </Label>

                  <Input
                    value={editStakeProjData.pf_nomeExibicao}
                    onChange={e => this.setState({
                      editStakeProjData: {
                        ...editStakeProjData,
                        pf_nomeExibicao: e?.target?.value,
                      }
                    })}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>
                    Telefone
                  </Label>

                  <MaskedInput
                      unmask
                      mask="(00) 00000-0000"
                      lazy={false}
                      disabled={false}
                      value={editStakeProjData.pf_celProf?.toString()}
                      onAccept={value => {
                        this.setState({editStakeProjData: {
                          ...editStakeProjData,
                          pf_celProf: value || null,
                        }})
                      }}
                    />
                </FormGroup>
                <FormGroup>
                  <Label>
                    E-mail
                  </Label>

                  <Input
                    value={editStakeProjData.pf_emailProf}
                    onChange={e => this.setState({
                      editStakeProjData: {
                        ...editStakeProjData,
                        pf_emailProf: e?.target?.value,
                      }
                    })}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>
                    Atuação
                  </Label>
                  <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecionar..."
                  value={selPapel && selPapel?.filter(x => (x.value === editStakeProjData.papel_id))}
                  options={selPapel || []}
                  isDisabled={!selPapel}
                  isLoading={!selPapel}
                  onChange={e => this.setState( {
                    editStakeProjData: {
                    ...editStakeProjData,
                    papel_id: e.value,
                    papel_nome: e.label,
                  }
                  })}
  />
                </FormGroup>
              </>
            }

          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.setState({ editStakeProjData: {}, editStakeProjModalIsOpen: false })}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                await this.handleEditSubmit()
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </Modal>


        <Card>
            <CardBody>
              <Row>
                <Col>
                 <CardHeader>
                  Stakeholders
                 </CardHeader>
                 <DataTable
                      className="table-clickable"
                      data={{
                        columns: [
                          {
                            label: '',
                            field: 'but1',
                          },
                          {
                            label: '',
                            field: 'but',
                          },
                          {
                            label: 'Nome',
                            field: 'pf_nomeExibicao',
                          },
                          {
                            label: 'Papel',
                            field: 'papel_nome',
                          },
                          {
                            label: 'E-mail',
                            field: 'pf_emailProf',
                          },
                          {
                            label: 'Telefone',
                            field: 'pf_celProf',
                          },
                        ],
                        rows: data.map(i => ({
                          but1:
                            <Button
                              title="Editar"
                              className="ml-2"
                              color="light"
                              size="sm"
                              onClick={()  => {
                                  this.setState({
                                    editStakeProjData: {
                                      projStake_id: i.projStake_id,
                                      pf_id: i.pf_id,
                                      pf_nomeExibicao: i.pf_nomeExibicao,
                                      proj_id: i.proj_id,
                                      papel_id: i.papel_id,
                                      papel_nome: i.papel_nome,
                                      pf_emailProf: i.pf_emailProf,
                                      pf_celProf: i.pf_celProf,
                                    }, editStakeProjModalIsOpen: true})
                              }}
                            >
                              <i className="ri-pencil-fill" />
                            </Button>,
                          but:
                            <Button
                              title="Excluir"
                              className="ml-2"
                              color="light"
                              size="sm"
                              onClick={() => this.openDeleteConfirm(i)}
                            >
                              <i className="ri-delete-bin-6-line" />
                            </Button>,
                          pf_nomeExibicao: i.pf_nomeExibicao,
                          papel_nome: i.papel_nome,
                          pf_emailProf: i.pf_emailProf,
                          pf_celProf: i.pf_celProf,
                        })),
                      }}
                    />
                </Col>
              </Row>
            </CardBody>
          </Card>


        </>


      )
    }


    return null
  }
}
export default StakeProj
